import React, { useMemo, useState } from "react";
import axios from "axios";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import * as Yup from "yup";

import domain from "../../../reusecomponent/domain";
import {
  SuccessToastContainer,
  ErrorToastContainer,
} from "../../function/CustomFunction";
import UploadModal from "../../../reusecomponent/UploadModal";

function CreateContactModal({
  showModal,
  onClose = () => {},
  editMode = false,
  editData = null,
}) {
  const token = useSelector((state) => state.Token.value);
  const [loading, setLoading] = useState(false);
  const [file,setFile] = useState(null);


  const initialValues = useMemo(
    () => ({
      name: editData?.name || "",
      number: editData?.number || "",
      email: editData?.email || "",
      address: editData?.address || "",
      city: editData?.city || "",
      district: editData?.district || "",
      state: editData?.state || "",
      pincode: editData?.pincode || "",
      profilePicture: null,
      profilePicturePath: null,
    }),
    [editData]
  );


  const validationSchema = Yup.object({
    name: Yup.string()
      .min(2, "Name too short")
      .required("Name is required"),

    // ✅ Mobile required + only digits + 7–15 length
    number: Yup.string()
      .matches(/^[0-9]+$/, "Only numbers allowed")
      .min(7, "Invalid mobile number")
      .max(15, "Invalid mobile number")
      .required("Mobile number is required"),

    // ✅ Optional fields
    email: Yup.string().email("Invalid email").nullable(),
    address: Yup.string().nullable(),
    city: Yup.string().nullable(),
    district: Yup.string().nullable(),
    state: Yup.string().nullable(),

    // ✅ Optional pincode (if entered must be 6 digits)
    pincode: Yup.string().matches(/^[0-9]{6}$/, {
      message: "Pincode must be 6 digits",
      excludeEmptyString: true,
    }),

    // ✅ Optional image validation
    profilePicture: Yup.mixed().nullable()
      .test(
        "fileSize",
        "Image must be less than 2MB",
        (file) => !file || file.size <= 2 * 1024 * 1024
      )
      .test(
        "fileType",
        "Only JPG, JPEG or PNG allowed",
        (file) =>
          !file ||
          ["image/jpeg", "image/jpg", "image/png"].includes(file.type)
      ),

  });


  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const formData = new FormData();

      Object.keys(values).forEach((key) => {
        if (key !== "profilePicture" && values[key]) {
          formData.append(key, values[key]);
        }
      });

      const url = editMode
        ? `${domain()}/contact-update/${btoa(editData.id)}`
        : `${domain()}/contact`;

      const res = await axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.status) {
        SuccessToastContainer(res.data.message);
        formik.resetForm();
        onClose();
      } else {
        ErrorToastContainer(res.data.message);
      }
    } catch {
      ErrorToastContainer("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema,
    onSubmit: handleSubmit,
  });

  console.log(formik.values);

  const FilePathUpdate = (path) => {
    if(path){
      formik.setFieldValue("profilePicturePath", path);
    }
    setFile(null);
  } 

  if (!showModal) return null;

  return (
    <div
      className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(8px)",
        zIndex: 1050,
      }}
      onClick={onClose}
    >
      {file != null && (
        <UploadModal FilePathUpdate={FilePathUpdate} file={file} url={`${domain()}/whatsapp/contact_profile_picture`}/>
      )}
      
      <div
        className="bg-white rounded-4 shadow-lg"
        style={{
          width: "90%",
          maxWidth: "500px",
          maxHeight: "90vh",
          overflow: "auto",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div
          className="d-flex justify-content-between align-items-center p-4 border-bottom"
          style={{
            background: "linear-gradient(135deg, #075E54, #128C7E)",
            color: "white",
          }}
        >
          <h5 className="mb-0">
            {editMode ? "Update Contact" : "Save Contact"}
          </h5>
          <FontAwesomeIcon icon={faXmark} onClick={onClose} />
        </div>

        <form className="p-4" onSubmit={formik.handleSubmit}>
          {/* PROFILE PICTURE */}
          <div className="text-center mb-4">
            <label style={{ cursor: "pointer" }}>
              <div
                className="rounded-circle d-flex align-items-center justify-content-center"
                style={{
                  width: 100,
                  height: 100,
                  border: "3px dashed #075E54",
                  margin: "auto",
                  overflow: "hidden",
                }}
              >
                {formik.values.profilePicture ? (
                  <img
                    src={URL.createObjectURL(formik.values.profilePicture)}
                    alt=""
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  "Upload"
                )}
              </div>

              <input
                hidden
                type="file"
                accept="image/*"
                onChange={(e) => {
                    setFile(e.target.files[0]);
                    formik.setFieldValue("profilePicture",e.target.files[0]);
                }}
              />
            </label>
          </div>

          {/* NAME */}
          <input
            className="form-control "
            name="name"
            placeholder="Enter full name"
            value={formik.values.name}
            onChange={formik.handleChange}
          />
          <small className="text-danger">{formik.errors.name}</small>

          {/* PHONE */}
          <PhoneInput
            country="in"
            className="mt-3"
            value={formik.values.number}
            onChange={(v) => formik.setFieldValue("number", v)}
            inputStyle={{ width: "100%" }}
          />
          <small className="text-danger">{formik.errors.number}</small>

          {/* REST UI SAME AS BEFORE */}
          <input className="form-control mt-3" name="email" placeholder="Enter email address" value={formik.values.email} onChange={formik.handleChange} />
          <textarea className="form-control mt-3" name="address" placeholder="Enter address" value={formik.values.address} onChange={formik.handleChange} />

          <div className="row mt-3">
            <div className="col">
              <input className="form-control" name="city" placeholder="Enter city" value={formik.values.city} onChange={formik.handleChange} />
            </div>
            <div className="col">
              <input className="form-control" name="district" placeholder="Enter district" value={formik.values.district} onChange={formik.handleChange} />
            </div>
          </div>

          <div className="row mt-3">
            <div className="col">
              <input className="form-control" name="state" placeholder="Enter state" value={formik.values.state} onChange={formik.handleChange} />
            </div>
            <div className="col">
              <input className="form-control" name="pincode" placeholder="Enter PIN code" value={formik.values.pincode} onChange={formik.handleChange} />
            <small className="text-danger">{formik.errors.pincode}</small>
            </div>
          </div>

          <div className="d-flex gap-3 mt-4">
            <button type="button" className="btn btn-light w-50" onClick={onClose}>
              Cancel
            </button>
            <button type="submit" className="btn w-50" style={{ background: "#075E54", color: "white" }}>
              {loading ? "Saving..." : editMode ? "Update Contact" : "Create Contact"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default React.memo(CreateContactModal);